import React from "react";
import { Box, Alert, Typography } from "@mui/material";
import { usePermissions } from "../../hooks/usePermissions";
import { LoadingScreen } from "./LoadingScreen";
import { useOutletContext } from "react-router-dom";

/**
 * Standard Permission Denied component for all modules.
 * @param {string} message - Custom message to display.
 */
export const PermissionDenied = ({ message }) => {
  const { isLoading } = usePermissions();
  const context = useOutletContext();
  const isCompanySwitching = context?.isCompanySwitching || false;

  if (isLoading && !isCompanySwitching) {
    return <LoadingScreen message="Verifying permissions..." />;
  }

  return (
    <Box sx={{ width: "100%", p: 4, display: 'flex', justifyContent: 'center' }}>
      <Alert 
        severity="error" 
        variant="filled" 
        sx={{ 
          width: '100%', 
          maxWidth: '800px',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>Permission Denied</Typography>
        <Typography variant="body1">
          {message || "You do not have permission to access this module. Please contact your administrator."}
        </Typography>
      </Alert>
    </Box>
  );
};
